export default __webpack_public_path__ + "static/usage-step-2-fb70eeeda92c89ecc66daa7528478d51.svg";